import { useTheme } from '@emotion/react'
import React from 'react'
import { Product, useFeature } from '@news-mono/web-common'
import { PubfeedProps } from './Pubfeed.routing'

const linkbyPubfeedTopicMapping: Record<Product, string[]> = {
    perthnow: ['lifestyle', 'entertainment', 'shop-now'],
    sevennews: ['lifestyle/sponsored'],
    thenightly: [],
    thewest: [],
}

export const Pubfeed = ({ publication, WrappingComponent }: PubfeedProps) => {
    const theme = useTheme()
    const product = theme.kind
    const isPubfeedEnabled = useFeature('linkby-pubfeed')

    // If it's not enabled, don't put any effort into the rendering of the component
    if (!isPubfeedEnabled) {
        return null
    }

    const topicsToCheck = linkbyPubfeedTopicMapping[product] || []

    // No topics to check for this product, so don't render the component
    if (topicsToCheck.length === 0) {
        return null
    }

    const isPrimaryTopicIncluded =
        publication.primaryTopic &&
        (topicsToCheck.includes(publication.primaryTopic.id) ||
            topicsToCheck.some((topic) =>
                publication.primaryTopic.id.startsWith(`${topic}/`),
            ))
    const isSecondaryTopicIncluded =
        publication.secondaryTopics &&
        publication.secondaryTopics.some(
            (topic) =>
                topicsToCheck.includes(topic.id) ||
                topicsToCheck.some((t) => topic.id.startsWith(`${t}/`)),
        )

    const shouldRender = isPrimaryTopicIncluded || isSecondaryTopicIncluded
    const Wrapper = WrappingComponent ? WrappingComponent : React.Fragment

    return shouldRender ? (
        <Wrapper>
            <div className="linkby-widget" data-type="listicle"></div>
        </Wrapper>
    ) : null
}
